import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps'
const GMAP_API_KEYS = process.env.VUE_APP_GMAP_API_KEYS.split(' | ')
const RANDOM_KEY_IND = Math.floor(Math.random() * GMAP_API_KEYS.length)
const API_KEY = GMAP_API_KEYS[RANDOM_KEY_IND]

Vue.use(VueGoogleMaps, {
	load: {
		key: API_KEY,
		libraries: 'places',
	}
})